import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from '../../../constants/colors/Colors';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
export const useStyles = makeStyles((theme) => ({
    invoiceHeading: {
        fontSize: 26,
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.001em',
        color: colors.titleColor,
        marginTop: 30,
        marginBottom: -20,
    },
    searchAndButtonsRow: {
        marginTop: 28,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        "@media (max-width: 1200px)": {
            display: 'block',
        },
    },
    inputWithIconContainer: {
        width: '100%',
        display: "inline-flex",
        alignItems: 'center',
    },
    searchInput: {
        height: 52,
        width: 566,
        backgroundColor: '#FAFAFB',
        borderRadius: 8,
        color: '#5B6773',
        border: '1px solid #D4DDE4',
        boxSizing: 'border-box',
        paddingLeft: 15,
        letterSpacing: '-0.1px',
        fontSize: 14,
        fontWeight: '400',
        fontStyle: 'normal',
        paddingRight: 60,
        "@media (max-width: 1500px)": {
            width: '80%'
        },
        "@media (max-width: 1200px)": {
            width: '100%',
        },
    },
    iconContainer: {
        backgroundColor: '#FAFAFB',
        width: 30,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        right: 33.5,
        height: 42,
        "@media (max-width: 1200px)": {
            position: 'absolute',
            right: 60,
        },
    },
    btnsRow: {
        display: 'inline-flex',
        "@media (max-width: 1200px)": {
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 20,
        },
    },
    creditNumber: {
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
        fontStyle: 'normal',
        whiteSpace: 'nowrap',
        "@media (max-width: 568px)": {
            fontSize: 14,
        },
    },
    allBtnsContainer: {
        marginLeft: 60,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        "@media (max-width: 1200px)": {
            marginLeft: 0,
        },
    },
    twoBtnsContainer: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    singleBtnContainer: {
        height: 52,
        width: 52,
        backgroundColor: '#FFFFFF',
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
        cursor: 'pointer',
        "@media (max-width: 568px)": {
            width: 32,
            height: 32,
            marginRight: 5,
        },
        "@media (max-width: 375px)": {
            width: 22,
            height: 22,
            marginRight: 5,
        },
    },
    iconImg: {
        "@media (max-width: 568px)": {
            width: 12,
            height: 12,
        },
        "@media (max-width: 375px)": {
            width: 8,
            height: 8,
        },
    },
    threeBtnsContainer: {
        display: 'inline-flex',
        marginLeft: 17,
        alignItems: 'center',
        "@media (max-width: 568px)": {
            marginLeft: 7,
        },
    },
    eventContainer: {
        borderRadius: 12,
        marginTop: 20,
    },
    table: {
        minWidth: 950,
        [theme.breakpoints.down('sm')]: {
            width: 1500,
        },
    },
    bulletIcon: {
        width: 6,
        height: 6,
        marginRight: 5,
    },
    butlletIconAndStateRow: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    eyeIcon: {
        width: 16,
        height: 11,
        cursor: 'pointer',
    },
    uploadIcon: {
        width: 16,
        height: 11,
        cursor: 'pointer',
    },
    iconsContainerRow: {
        width: 60,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));


export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 16,
        paddingLeft: 30,
    },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);